import React, {useState} from 'react';
import CustomDataTable from "../CustomDataTable";
import {trans} from "../../utils";


const StatusHistory = ({params}) => {
    const columns = [
        {data:"created_at",title:"Date"},
        {data:"causer.name",title:"By"},
        {data:function (full){
            return full.properties.attributes["status_data.title_en"]
            },title:"Status"},
    ]
    return(
       <>
            <div className="card-header cursor-pointer">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{trans('Status History')}</h3>
                </div>
            </div>
            <div className="card-body p-9">
                <CustomDataTable columns={columns} url={"WorkOrderStatusHistory?wo_id="+params.id} table_id="statusHistory" order={ [[0, "asc"]]} />
            </div>
        </>
    )

}
export default StatusHistory
